import * as React from "react";
import { useState, useEffect, useContext } from "react";
import Title from "../../Title";
import {
  FormControl,
  FormLabel,
  FormControlLabel,
  FormHelperText,
  FormGroup,
  TextField,
  Button,
  Slider,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  Link,
} from "@mui/material";
import Container from "@mui/material/Container";
import { InputLabel } from "@mui/material";
import { Select } from "@mui/material";
import { MenuItem } from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import AuthContext from "../../../context/AuthContext";
import DataContext from "../../../context/DataContext";

function preventDefault(event) {
  event.preventDefault();
}

export default function ClientPositionDropdown({
  clientPositions,
  setClientPositions,
  clientPositionId,
  setClientPositionId,
  handlePositionDropdownChange,
  handleClientDropdownChange,
  clientId,
  setClientId,
}) {
  let { clients, positions, } = useContext(DataContext);
  let { isAdmin } = useContext(AuthContext);

  const onClientChange = (id) => {
    setClientPositionId(null);
    setClientId(id);
    setClientPositions(
      positions.filter((position) => position.client === id),
    );
    handleClientDropdownChange(id);
  };

  const onPositionChange = (id) => {
    setClientPositionId(id);
    handlePositionDropdownChange(id);
  };


  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 120,
      },
    },
  };

  return (
    // <Card>
    // <CardContent>
    <Grid>
      {isAdmin ? (
        <Grid item sx={{ ml: 3 }}>
          <Title>Select Views (Admin Only)</Title>
        </Grid>
      ) : (
        <Typography color="#757575" variant="h4" sx={{ m: 2 }}>
        Position Metrics
      </Typography>)
      }

      <Grid container spacing={1} sx={{ justifyContent: "left" }}>
        { isAdmin &&
        <Grid item>
          <FormControl sx={{ minWidth: 240, ml: 1 }}>
            <InputLabel id="demo-multiple-checkbox-label">
              Choose Client
            </InputLabel>
            <Select
              labelId="client-label"
              id="client"
              value={clientId || ""}
              label="Client"
              onChange={(e) => onClientChange(e.target.value)}
              input={<OutlinedInput label="Choose Client" />}
              MenuProps={MenuProps}
            >
              {clients.map((client, index) => {
                return (
                  <MenuItem key={client.id} value={client.id}>
                    {client.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>}

        <Grid item>
          <FormControl
            sx={{ minWidth: 240, ml: 1 }}
            disabled={clientPositions.length == 0}
          >
            <InputLabel id="demo-multiple-checkbox-label">
              Choose Position
            </InputLabel>
            <Select
              labelId="clientPosition-label"
              id="clientPosition"
              value={clientPositionId || ""}
              label="Position"
              onChange={(e) => onPositionChange(e.target.value)}
              input={<OutlinedInput label="Choose Position" />}
              MenuProps={MenuProps}
            >
              {clientPositions.map((position, index) => {
                return (
                  <MenuItem key={position.id} value={position.id}>
                    {position.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Grid>
    // </CardContent>
    // </Card>
  );
}
